import { render, staticRenderFns } from "./NovoAfastamento.vue?vue&type=template&id=c6dc23f6&"
import script from "./NovoAfastamento.vue?vue&type=script&lang=js&"
export * from "./NovoAfastamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports